const FREE_TRIAL = 'free-trial';
export const BillingMethod = {
  [FREE_TRIAL]: 'Free trial'
};
